import { render, staticRenderFns } from "./TableProfit.vue?vue&type=template&id=d0c33578&scoped=true"
import script from "./TableProfit.vue?vue&type=script&lang=js"
export * from "./TableProfit.vue?vue&type=script&lang=js"
import style0 from "./TableProfit.vue?vue&type=style&index=0&id=d0c33578&prod&scoped=true&lang=scss&ref=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0c33578",
  null
  
)

export default component.exports